/* ============================================================
   JGNT List - comportamiento

   Un solo listener delegado en document, con bandera global: la
   seccion puede aparecer varias veces en una pagina y el editor
   la recarga entera al cambiar un ajuste.

   Cada renglon apunta a su hoja por id (data-jgnt-list-open), asi
   que no hace falta recorrer ni indexar nada al cargar: el
   trabajo se hace solo cuando alguien toca un renglon.
   ============================================================ */

(function () {
  if (window.jgntListReady) return;
  window.jgntListReady = true;

  function closeSheet(sheet) {
    if (!sheet || !sheet.open) return;

    sheet.classList.add('jgnt-list__sheet--closing');

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      sheet.classList.remove('jgnt-list__sheet--closing');
      sheet.close();
    };

    sheet.addEventListener('animationend', finish, { once: true });
    /* Respaldo: si la pestana pierde el foco a media animacion,
       animationend no dispara y la hoja se queda abierta. */
    setTimeout(finish, 400);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    /* --- Abrir --- */
    var opener = event.target.closest('[data-jgnt-list-open]');
    if (opener) {
      var sheet = document.getElementById(opener.getAttribute('data-jgnt-list-open'));
      if (!sheet) return;

      sheet.showModal();
      /* showModal enfoca el primer elemento enfocable, que seria
         la tacha y saldria con anillo. Se mueve el foco a la hoja,
         que si conserva la trampa de foco del modal. */
      sheet.focus();
      return;
    }

    /* --- Cerrar con la tacha --- */
    var closer = event.target.closest('[data-jgnt-list-close]');
    if (closer) {
      closeSheet(closer.closest('.jgnt-list__sheet'));
      return;
    }

    /* --- Cerrar tocando el velo ---
       Un dialog nativo entrega el clic del ::backdrop al propio
       dialog, asi que basta comparar el objetivo. */
    if (event.target.classList.contains('jgnt-list__sheet')) {
      closeSheet(event.target);
    }
  });

  /* Escape: se cancela el cierre nativo, que seria seco, y se
     corre el mismo cierre animado. */
  document.addEventListener('cancel', function (event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.classList.contains('jgnt-list__sheet')) return;

    event.preventDefault();
    closeSheet(event.target);
  });
})();
